import {XauditModel} from '../../xaudit.model';
import {NotificationToFrontAppointmentDataModel} from './notification-to-front-appointment-data.model';
import {DataPatientCaseWorkItemToothModel} from '../../teeth/data-patient-case-work-item-tooth.model';

export class NotificationToFrontDataModel extends XauditModel {
  NotificationFrontID: string;
  PatientID: string;
  Comment: string;
  CaseWorkItemId: string;

  history: NotificationToFrontDataModel[];
  dataNotificationToFrontAppoitments: NotificationToFrontAppointmentDataModel[];
  dataPatientCaseWorkItemTeeth: DataPatientCaseWorkItemToothModel[];
}
